
import { useState } from "react";
import './App.css';
import leftPhone from "./assets/Iphone-frame-left.png";
import rightPhone from "./assets/Iphone-frame-right.png";
import arrow from "./assets/trend.png";
import nutrition from "./assets/nutrition.png";
import dumbell from "./assets/dumbell.png";
import { supabase } from "./lib/supabaseClient"; 


function FeatureCard({ imageSrc, title, children }) {
  return (
    <div className="feature-card">
      <div className="feature-header">
        <div className="feature-icon">
          <img src={imageSrc} alt={title} className="feature-img" />
        </div>
        <h3 className="feature-title">{title}</h3>
      </div>
      <p className="feature-text">{children}</p>
    </div>
  );
}

function App() {

  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | ok | error
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) return;

    setStatus("loading");
    setMessage("");

    const { error } = await supabase
      .from("waitlist_emails")
      .insert([{ email: trimmed }]);
    if (error) {
      setStatus("error");
      setMessage(
        error.code === "23505" ? "You're already on the list." : "Something went wrong. Try again."
      );
    } else {
      setStatus("ok");
      setMessage("Thanks! You're on the list.");
      setEmail("");
    }
  };


  return (
    <div className="page">
      {/* Top brand bar */}
      <header className="nav">
        <div className="logo">Vanta</div>
      </header>

      <main className="main">
        {/* HERO SECTION */}
        <section className="hero">
          <img
            src={leftPhone}
            alt="Vanta workouts screen"
            className="phone phone-left"
          />

          <div className="hero-content">
            <h1 className="hero-title">
              Train Smarter.
              <br />
              Work Harder.
            </h1>
            <p className="hero-subtitle">
              Vanta brings your workouts, climbing sessions, and nutrition into
              one clean, focused app – so you can spend less time planning and
              more time progressing.
            </p>

            <div className="waitlist-card">
              <p className="waitlist-heading">
                Sign up now to be notified when we release.
              </p>
              <form className="waitlist-form" onSubmit={handleSubmit}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="waitlist-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button
                  type="submit"
                  className="waitlist-button"
                  disabled={status === "loading"}
                >
                  {status === "loading" ? "Joining..." : "Join Waitlist"}
                </button>
              </form>
              {message && (
                <div className={`waitlist-message ${status}`}>
                  {message}
                </div>
              )}
            </div>
          </div>

          <img
            src={rightPhone}
            alt="Vanta training plan screen"
            className="phone phone-right"
          />
        </section>

        {/* FEATURES SECTION */}
        <section className="features">
          <FeatureCard imageSrc={arrow} title="Metrics">
            Track all workouts and see progress between all rep and set ranges.
            Climbing, cardio, push, pull – all the good stuff.
          </FeatureCard>

          <FeatureCard  imageSrc={dumbell} title="Nutrition">
            Track nutritional data and log meals of your choice or pre-loaded
            plans so you can stay on top of your macros.
          </FeatureCard>

          <FeatureCard imageSrc={nutrition} title="Workouts">
            Plan from a list of personal workouts or try our pre-made plans with
            custom timers, sets, and reps.
          </FeatureCard>
        </section>
      </main>
    </div>
  );
}

export default App;
